import document from './document';

const defect = `
    additionalData {
        areaDeviationDetails {
            areaBalcony
            areaLowRooms
            areaNormalRooms
            areaNotHeated
            contractBefore2014
            livingArea
            measuredDate
        }
        elevatorDefectFloors
        moldDetails {
            color
            size
            wet
        }
        room
        roomsize
    }
    additionalProves {
        ${document}
    }
    additionalQuestionAnswers {
        answer
        questionId
    }
    agreedRemovalDate
    agreementOverKnownDefect
    defectEnded
    defectKind {
        additionalInformation
        additionalInputs
        additionalQuestions
        alternativeDefect
        children
        description
        extraload
        icon
        mainQuestion
        name
        priority
        tooltip
    }
    defectKindId
    defectStarted
    denialReasons
    howWasLandlordInformed
    id
    isImpairment
    landlordInformedSince
    landlordReaction
    otherNotificationKind
    payUnderReserveSince
    referenceDecisions {
        courtName
        courtTypeId
        courtTypeName
        defectId
        defectName
        id
        judgmentDate
        reduction
        referenceNumber
    }
    rentArrears
    reduction
    selfCaused
    # status
`;

export default defect;
